/* eslint-disable angular/window-service */
/* eslint-disable camelcase */
/* eslint-disable angular/no-run-logic */
require('babel-polyfill')
require('url-polyfill')

require('textangular')
require('angular-spinner')

window._ = require('underscore')
window.moment = require('moment')
window.rangy = require('rangy')
window.rangy.saveSelection = require('rangy/lib/rangy-selectionsaverestore')
require('./shared/ng-nested-combobox.js')
require('./shared/spin.min.js')

// File upload on the admin-panel.html
require('./shared/angular-file-upload-shim.js')
require('./shared/angular-file-upload.min.js')

require('../ng-slider/src/css/ng-slider.css')
require('../ng-slider.min.js')
// Require('../olark-chat-box.js')
/*****************************************************/
/*          start:JQUERY-QUERY-BUILDER               */
/*****************************************************/
require('../node_modules/bootstrap-select/dist/css/bootstrap-select.min.css')
require('../node_modules/selectize/dist/css/selectize.bootstrap3.css')
require('../node_modules/jQuery-QueryBuilder/dist/css/query-builder.default.min.css')
require('../node_modules/socket.io-client/dist/socket.io.js')
require('selectize')
require('bootstrap-select')
require('interact.js')
window.SQLParser = require('../node_modules/sql-parser/browser/sql-parser.js')
/*****************************************************/
/*             end:JQUERY-QUERY-BUILDER              */
/*****************************************************/

require('../bower_components/font-awesome/css/font-awesome.min.css')

require('../styles/animate.css')
require('../styles/bootstrap-dropdownhover.min.css')
require('../styles/bootstrap-dropdownhover.min.js')
require('../styles/style-scss/main.scss')

// Require('../styles/main.css');

require('textangular/dist/textAngular-sanitize.js')

require('./vendors/jquery.flot.animator.min.js')
require('./vendors/jquery.sparkline.min.js')
require('../bower_components/angular-route/angular-route.min.js')
require('../bower_components/angular-animate/angular-animate.min.js')
require('../bower_components/angular-clipboard/angular-clipboard.js')
require('../bower_components/angular-bootstrap/ui-bootstrap-tpls.min.js')
require('../bower_components/angular-cookies/angular-cookies.js')
window.toastr = require('../bower_components/toastr/toastr.min.js')
require('../bower_components/bootstrap-file-input/bootstrap.file-input.js')
require('../bower_components/jquery.slimscroll/jquery.slimscroll.min.js')
require('../bower_components/flot/jquery.flot.js')
require('../bower_components/flot/jquery.flot.resize.js')
require('../bower_components/flot/jquery.flot.pie.js')
require('../bower_components/flot/jquery.flot.stack.js')
require('../bower_components/flot.tooltip/js/jquery.flot.tooltip.min.js')
require('../bower_components/flot/jquery.flot.time.js')
require('../bower_components/isteven-angular-multiselect/isteven-multi-select.js')
require('../node_modules/angular-drag-and-drop-lists/angular-drag-and-drop-lists.js')
require('../bower_components/angular-bootstrap-colorpicker/js/bootstrap-colorpicker-module.js')
require('../bower_components/angular-bootstrap-colorpicker/css/colorpicker.css')
require('angular-filter')
require('../bower_components/angular-translate/angular-translate.js')
require('../bower_components/angular-translate-loader-static-files/angular-translate-loader-static-files.js')
require('../bower_components/ng-tags-input/ng-tags-input.min.js')

require('./chart/ChartCtrl.js')
require('./chart/ChartDirective.js')
require('./edit-email/EditEmailCtrl.js')
require('./form/Form.js')
require('./form/TabsDemoCtrl.js')
require('./form/TagsDemoCtrl.js')

/** *********  Start: APIs MODULE  **************/
require('./shared/api/module')
require('./shared/api/api')
require('./shared/grid/module')
require('./shared/api/legacy.api')
require('./shared/api/preferences.api')
/** *********   End: APIs MODULE   **************/

/** *********  Start: Controllers MODULE  **************/
require('./shared/controllers/module')
require('./shared/controllers/app')
require('./shared/controllers/nav')
require('./shared/controllers/column-select-modal')
/** *********   End: Controllers MODULE   **************/

/*****************************************************/
/*                   DIRECTIVES                      */
/*****************************************************/
require('./shared/directives/directives.js')
// Header
require('./shared/directives/header/header.js')
require('./shared/directives/header/api.js')
// Footer
require('./shared/directives/footer/module')
require('./shared/directives/footer/footer')
// Angular-QueryBuilder
// require('./shared/api/query-builder')
// require('./shared/directives/angular-querybuilder/directive')
// require('./shared/directives/angular-querybuilder/styles/angular-query-builder.css')
// Column Selector
require('./shared/directives/column-selector/api')
require('./shared/directives/column-selector/directive')
// Lawyer Preferences
require('./shared/directives/lawyer-preferences/directive')

// Grid Group Pipeline
require('./shared/directives/group-pipeline/directive')
// Lawyer Salary
require('./shared/directives/lawyer-salary/directive')
// Actions PoPup
require('./shared/directives/actions-popup/directive')

// General
require('./shared/directives/read-more-words.js')
require('./shared/directives/see-more.js')
require('./shared/directives/select-practice-areas.js')
require('./shared/directives/select-practice-areas-simple')
require('./shared/directives/modal-practice-areas')
require('./shared/directives/modal-locations')
require('./shared/directives/select-locations.js')
require('./shared/directives/multi-select-dropdown.js')
require('./shared/directives/pqe-slider-dropdown.js')
require('./shared/directives/assignee-admin-dropdown.js')
require('./shared/directives/practice-area-dropdown-ag-grid-temp.js')

/*****************************************************/
/*                    FILTERS                        */
/*****************************************************/
require('./shared/filters/module.js')
require('./shared/filters/firms-type-ahead.js')
require('./shared/filters/employer-type-ahead.js')
require('./shared/filters/limit-word.js')
require('./shared/filters/trust-as-resource.js')
require('./shared/filters/lawyers.js')
require('./shared/filters/selected-tags-lawyers.js')
require('./shared/filters/less-than.js')
require('./shared/filters/greater-than.js')
require('./shared/filters/opportunities.js')
require('./shared/filters/opportunities.js')
require('./shared/filters/inhouse-opportunities.js')
require('./shared/filters/firms.js')
require('./shared/filters/selected-practices.js')
require('./shared/filters/selected-tags.js')
require('./shared/filters/selected-inhouse-tags.js')
require('./shared/filters/jobs-by-pqe.js')
require('./shared/filters/inhouse-Jobs-by-pqe.js')
require('./shared/filters/locations.js')
require('./shared/filters/inhouse-locations.js')
require('./shared/filters/jobs-in-target-locations.js')
/*****************************************************/
/*                     SERVICES                      */
/*****************************************************/
require('./shared/services/module.js')
require('./shared/services/locations.js')
require('./shared/services/practices.js')
require('./shared/services/jobs.js')
require('./shared/services/logger.js')
require('./shared/services/user-service.js')
require('./shared/services/user-service.api.js')
require('./shared/services/account-permission.js')
require('./shared/services/shared-properties.js')
require('./shared/services/current-lawyer.js')
require('./shared/services/socket.js')
require('./shared/services/defaultViewFilter.js')
/*****************************************************/
/*                    CONSTANTS                      */
/*****************************************************/
require('./shared/constants/module.js')
require('./shared/constants/constants.js')

require('./shared/DatepickerDemoCtrl.js')
require('./shared/TimepickerDemoCtrl.js')
require('./shared/type-ahead.ctrl.js')
require('./form/RatingDemoCtrl.js')
require('./shared/ProfileModalCtrl.js')

require('./sign-up/sign-up.ctrl.js')
require('./sign-up/sign-up.api')
require('./form/deleteMatterModalCtrl.js')
require('./form/deleteEducationModalCtrl.js')

require('./lawyer-profile/lawyer-profile.module.js')
require('./lawyer-profile/candidate-profile.api.js')
require('./lawyer-profile/LawyerProfileService.js')

/** ********* Start: Employment History DIRECTIVE **************/
require('./candidate-profile/employment-history/employmentHistoryLocationCtrl.js')
require('./candidate-profile/employment-history/employment-history.js')
require('./candidate-profile/employment-history/employmentHistoryService.js')
require('./candidate-profile/employment-history/employmentForm.js')
/** ********* End: Employment History DIRECTIVE **************/

require('./shared/clear-icon.js')

require('./sign-in/sign-in.ctrl.js')
require('./change-password/ResetPassCtrl.js')
require('./refer-friend/refer-friend.ctrl.js')
require('./shared/CreateProfileModalCtrl.js')
require('./user-profile/ProfileCtrl.js')
require('./shared/edit-candidate.ctrl.js')
require('./candidate-applications/candidate-application.ctrl.js')
require('./candidate-applications/candidate-application.api.js')
require('./admin-applied-jobs/AdminAppliedJobs.js')
require('./form/is-old-browser.ctrl.js')
require('./home/HomePageCtrl.js')
require('./shared/jobPracticesModalCtrl.js')
require('./job/JobCreateCtrl.js')
require('./job/JobEditCtrl.js')
require('./job/deleteJobModalCtrl.js')

/** ********* WelcomePopup**************/

require('./matches/welcome-modal-popup/welcome-modal.directive.js')
require('./matches/welcome-modal-popup/welcome-modal.html')

require('./shared/directives/modal-hide-positions-employer/hide-position-employer.directive')

require('./inhouse-jobs/in-house-jobs.ctrl.js')
require('./inhouse-jobs/in-house-jobs.api.js')
require('./shared/directives/modal-hide-positions-employer/hide-position-employer.api.js')

require('./matches/matches.ctrl.js')
require('./matches/matches.api.js')

require('./make-me-offer/make-me-an-offer.ctrl.js')
require('./make-me-offer/make-me-an-offer.api.js')

require('./form/email-subscriptions.ctrl.js')

require('./form/FormDirective.js')
require('./form/FormValidation.js')

require('./job-application-history/jobApplicationHistoryCtrl.js')
require('./job-application-history/jobApplicationHistoryServices.js')
require('./job-application-history/viewJobApplicationBody.js')

require('./map/Map.js')

/** *********NOTES MODULE**************/
require('./notes/module')
require('./candidate-profile/candidate-profile.module')

/** *********CANDIDATE PROFILE RECOMMENDATIONS MODULE**************/

require('./page/PageCtrl.js')
require('./table/TableCtrl.js')
require('./task/Task.js')

require('./ui/UICtrl.js')
require('./ui/UIDirective.js')

require('./shared/localize.js')

require('./invite-friend/invite-friend.ctrl.js')
require('./invite-friend/invite-friend.api.js')
require('./sign-in/log-in.api.js')
require('./shared/api/api.js')
require('./admin-panel/candidate-listing/candidate-listing.api')
require('./admin-panel/candidate-listing/candidate-listing.ctrl.js')

require('./admin-panel/position-listing/position-listing.ctrl.js')
require('./admin-panel/position-listing/inactive-position-listing.ctrl.js')
require('./admin-panel/position-listing/position-listing.api.js')

require('./shared/directives/position-details/position-details.directive.js')
require('./shared/directives/position-details/position-details.ctrl.js')

require('./shared/directives/create-update-position/create-update-position.directive.js')
require('./shared/directives/create-update-position/create-update-position-modal.ctrl.js')
require('./shared/directives/create-update-position/create-update-position-page.ctrl.js')

require('./shared/directives/delete-position/delete-position.directive.js')
require('./shared/directives/delete-position/delete-position.ctrl.js')

require('./shared/directives/practice-area/practice-area.service')
require('./shared/directives/practice-area/practice-area-modal.ctrl')
require('./shared/directives/practice-area/practice-area-modal.directive.js')

require('./shared/directives/practice-area/practice-area-dropdown.directive')
require('./shared/directives/practice-area/practice-area-dropdown.ctrl')

require('./shared/directives/locations/locations-modal.ctrl.js')
require('./shared/directives/locations/locations-modal.directive.js')
require('./shared/directives/locations/locations.service.ctrl')

require('./shared/directives/locations/locations-dropdown.directive.ctrl')

require('./admin-profile/admin-profile.ctrl.js')
require('./admin-profile/admin-profile.api.js')

require('./admin-panel/email-listing/email-listing.ctrl.js')
require('./admin-panel/email-listing/email-listing.api.js')
require('./admin-panel/email-listing/email-preview/email-preview.ctrl.js')

require('./admin-panel/referral-listing/referral-listing.ctrl.js')
require('./admin-panel/referral-listing/referral-listing.api.js')

require('./shared/directives/date-modal/date-modal.directive.js')
require('./shared/directives/date-modal/date-modal.ctrl.js')
require('./shared/directives/date-modal/time-picker.ctrl.js')
require('./shared/directives/date-modal/date-picker.ctrl.js')

require('./shared/directives/clone-position/clone-position.directive.js')

require('./shared/directives/ag-grid-listing/ag-grid-listing.api')
require('./shared/directives/ag-grid-listing/ag-grid-listing.directive')
require('./shared/directives/ag-grid-listing/help-modal/help-modal.directive')
require('./shared/directives/ag-grid-listing/ag-grid-filters/filters.directive')
require('./shared/directives/ag-grid-listing/ag-grid-filters/add-filters/add-filters.directive')
require('./shared/directives/ag-grid-listing/ag-grid-filters/delete-filters/delete-filters.directive')

require('./admin-panel/employers-listing/employers.api.js')
require('./admin-panel/employers-listing/employers-listing.ctrl')
require('./shared/directives/create-update-employer/create-update-employer-page.ctrl')
require('./shared/directives/create-update-employer/create-update-employer-modal.ctrl')
require('./shared/directives/create-update-employer/create-update-employer.directive')
require('./shared/directives/delete-employer/delete-employer.directive.js')

require('./shared/directives/assign-agent-dropdown/assign-agent-dropdown.directive')
require('./shared/directives/file-upload')

require('./forgot-password/forgot-password.ctrl.js')
require('./forgot-password/forgot-password.api.js')

require('./admin-panel/application-listing/application-listing.ctrl.js')
require('./admin-panel/application-listing/applications.api.js')

require('./shared/directives/application/application-stages-setting/application-stages.api.js')

require('./shared/directives/application/application-status-dropdown/application-status-dropdown.directive')
require('./shared/directives/application/applications-stage-dropdown/application-stage-dropdown.directive')
require('./shared/directives/application/delete-applications/delete-application.directive')

require('./shared/directives/application/application-agent/application-agent.directive')
require('./shared/directives/application/application-agent/application-agent.api')
require('./shared/directives/application/application-stages-setting/application-stages-setting.directive')
require('./shared/directives/application/application-history/application-history.directive')

require('./about-you/about-you.ctrl')
require('./change-password/change-password.ctrl')

require('./admin-panel/recommendation-listing/recommendation-page.ctrl')
require('./admin-panel/recommendation-listing/recommendation-listing.api')
require('./admin-panel/recommendation-listing/recommendation-listing.ctrl')
require('./admin-panel/recommendation-listing/help-description-modal/help-description-modal.directive')

require('./hiring/hiring.ctrl')
require('./hiring/hiring.api')

require('./shared/directives/contact-admin/contact-admin.directive')
require('./shared/directives/application/application-modal/application-modal.directive')
require('./shared/directives/candidate-profile-modal/candidate-profile-modal.directive')

require('./shared/shared.api')

const ACCESS_DENIED = 406
const routesList = require('../config/routes.json')

const {version} = require('../package.json')

// Const environment = process.env.NODE_ENV

// If (environment === 'production') {
//   const SENTRY_DSN =
//     process.env.SENTRY_DSN ||
//     'https://e3109624ce5247099bf954b89cc8996a@o1414621.ingest.sentry.io/6754944'
//
//   // TODO: add datadog APM
// }

angular
  .module('app', [
    'ngRoute',
    'ngAnimate',
    'ui.bootstrap',
    'textAngular',
    'ngTagsInput',
    'app.constants',
    'app.lexstepHeader',
    'app.notes',
    'app.candidateProfile',
    'app.LawyerProfile',
    'app.services',
    'app.controllers',
    'app.directives',
    'app.directives.lexstepFooter',
    'app.filters',
    'app.form.validation',
    'app.ui.form.ctrls',
    'app.ui.form.directives',
    'app.jobApplicationHistory',
    'app.editEmail',
    'ngCkeditor',
    'app.emailBodyView',
    'isteven-multi-select',
    'app.api',
    'app.grid',
    'dndLists',
    'colorpicker.module',
  ])
  .config([
    '$routeProvider',
    '$locationProvider',
    '$logProvider',
    '$httpProvider',
    function config(
      $routeProvider,
      $locationProvider,
      $logProvider,
      $httpProvider
    ) {
      angular.lowercase = angular.$$lowercase
      $httpProvider.interceptors.push([
        '$log',
        () => ({
          request(config) {
            return config
          },
        }),
      ])
      $logProvider.debugEnabled(false)

      // Single resolve to verify lawyer status
      let staticRequire = require.context('./', true, /^\.\/.*\.html$/)

      routesList.forEach(route => {
        const providedRoute = Object.assign(
          {
            title: route.title
              ? route.title
              : 'LexStep - Find Jobs At The Best Law Firms',
            resolve: {
              checkPageAccess: userService => {
                return userService.authenticateRoute(route)
              },
            },
          },
          route.redirectTo && {redirectTo: route.redirectTo},
          route.template && {template: staticRequire(route.template)},
          route.templateUrl && {templateUrl: route.templateUrl},
          route.css && {css: route.css}
        )
        $routeProvider.when(route.path, providedRoute)
      })

      $routeProvider.otherwise({
        redirectTo: '/404',
      })
      return $locationProvider.html5Mode(true)
    },
  ])
  .run([
    '$rootScope',
    '$log',
    '$window',
    '$location',
    function run($rootScope, $log, $window, $location) {
      if (process.env.NODE_ENV === 'production') {
        $window.ga('create', 'UA-63533389-1', 'auto')
      } else {
        $window.ga('create', 'UA-123651854-1', 'auto')
      }

      $log.info('LexStep/angularjs v' + version + ' initialized.')

      $rootScope.envUrl = process.env.PUBLIC_URL
      $rootScope.serverEnvUrl = process.env.LEXSTEP_URL
      $rootScope.$on('$routeChangeStart', function on(event, next) {
        // Track pageview on state change
        $window.ga('send', 'pageview', $location.path())
        return $log.info(
          `starting a route change to '${next.$$route.originalPath}'`
        )
      })
      $rootScope.$on('$routeChangeError', function on(
        event,
        current,
        previous,
        rejection
      ) {
        if (
          rejection &&
          rejection.reason === ACCESS_DENIED &&
          rejection.redirectTo
        ) {
          $location.path(rejection.redirectTo)
        }
      })
      return $rootScope.$on('$routeChangeSuccess', function on(event, current) {
        if ($window.fbq) $window.fbq('track', 'ViewContent')

        var path = $location.path()
        var queryString = ''

        if (path.includes('?')) {
          // eslint-disable-next-line unicorn/prefer-string-slice
          queryString = path.substring(path.indexOf('?'), path.length)
        }

        if (!path.startsWith('/admin')) {
          analytics.page({
            path: path,
            search: queryString,
            title: current.$$route.title,
            url: $location.absUrl(),
          })
        }

        $rootScope.title = current.$$route.title

        return $rootScope.title
      })
    },
  ])



// WEBPACK FOOTER //
// ./scripts/app.js